/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmailAndName } from './emailAndName';


export interface AirtimeDeviceDto { 
    deviceId?: number;
    deviceTypeId?: string;
    comType?: AirtimeDeviceDto.ComTypeEnum;
    networkStatus?: AirtimeDeviceDto.NetworkStatusEnum;
    dataPlan?: AirtimeDeviceDto.DataPlanEnum;
    owners?: Array<EmailAndName>;
    lastReception?: string;
    airtimeNetworkStatusChangeRequested?: AirtimeDeviceDto.AirtimeNetworkStatusChangeRequestedEnum;
}
export namespace AirtimeDeviceDto {
    export const ComTypeEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type ComTypeEnum = typeof ComTypeEnum[keyof typeof ComTypeEnum];
    export const NetworkStatusEnum = {
        Activating: 'ACTIVATING',
        Activated: 'ACTIVATED',
        Deactivating: 'DEACTIVATING',
        Deactivated: 'DEACTIVATED',
        Suspending: 'SUSPENDING',
        Resuming: 'RESUMING',
        Changing: 'CHANGING',
        Invalid: 'INVALID',
        Changed: 'CHANGED'
    } as const;
    export type NetworkStatusEnum = typeof NetworkStatusEnum[keyof typeof NetworkStatusEnum];
    export const DataPlanEnum = {
        Unlimited: 'UNLIMITED',
        ThreeKbyte: 'THREE_KBYTE',
        SmithsonianSpecial: 'SMITHSONIAN_SPECIAL',
        PooledThreeKbyte: 'POOLED_THREE_KBYTE',
        PooledTwelveKbyte: 'POOLED_TWELVE_KBYTE',
        Test25Kbyte: 'TEST_2_5_KBYTE',
        Test4Kbyte: 'TEST_4_KBYTE'
    } as const;
    export type DataPlanEnum = typeof DataPlanEnum[keyof typeof DataPlanEnum];
    export const AirtimeNetworkStatusChangeRequestedEnum = {
        Activating: 'ACTIVATING',
        Activated: 'ACTIVATED',
        Deactivating: 'DEACTIVATING',
        Deactivated: 'DEACTIVATED',
        Suspending: 'SUSPENDING',
        Resuming: 'RESUMING',
        Changing: 'CHANGING',
        Invalid: 'INVALID',
        Changed: 'CHANGED'
    } as const;
    export type AirtimeNetworkStatusChangeRequestedEnum = typeof AirtimeNetworkStatusChangeRequestedEnum[keyof typeof AirtimeNetworkStatusChangeRequestedEnum];
}


export type ComTypeEnum = typeof AirtimeDeviceDto.ComTypeEnum[keyof typeof AirtimeDeviceDto.ComTypeEnum];
export type NetworkStatusEnum = typeof AirtimeDeviceDto.NetworkStatusEnum[keyof typeof AirtimeDeviceDto.NetworkStatusEnum];
export type DataPlanEnum = typeof AirtimeDeviceDto.DataPlanEnum[keyof typeof AirtimeDeviceDto.DataPlanEnum];
export type AirtimeNetworkStatusChangeRequestedEnum = typeof AirtimeDeviceDto.AirtimeNetworkStatusChangeRequestedEnum[keyof typeof AirtimeDeviceDto.AirtimeNetworkStatusChangeRequestedEnum];
